import { UploadState } from './state';
import { UploadAction } from './actions';
import { UPLOAD_DONE, UPLOAD_SET_CANCEL_TOKEN_SOURCE } from './types';

const initialState = {
    cancelTokenSource: undefined
};

export function uploadReducer(state: UploadState = initialState, action: UploadAction) {
    switch (action.type) {
        case UPLOAD_SET_CANCEL_TOKEN_SOURCE:
            return {
                ...state,
                cancelTokenSource: action.payload
            };
        case UPLOAD_DONE:
            return {
                ...state,
                cancelTokenSource: undefined
            };
        default:
            return state;
    }
}
